<template>
  <section>
    <div
      v-if="images.length === 0"
      class="empty"
      :style="{ backgroundImage: 'url(' + placeholder + ')' }"
    ></div>
    <div
      v-else
      :class="{
        single: images.length === 1,
        double: images.length === 2,
        four: images.length > 2
      }"
    >
      <retry-image
        v-for="(image, index) in images"
        :key="index"
        :url="url(image)"
        :timestamp="image.previewTimestamp"
        :bordered="!!image.border"
        class="image"
      >
      </retry-image>
    </div>
  </section>
</template>
<script>
import emptyCollection from '@/images/empty-collection.svg'
import emptyPackage from '@/images/empty-package.svg'
import emptyImage from '@/images/image-placeholder.svg'
import RetryImage from '@/components/ui/RetryImage'

export default {
  components: { RetryImage },
  props: {
    images: {
      type: Array,
      default: function () {
        return []
      }
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      emptyCollection
    }
  },
  computed: {
    placeholder() {
      if (this.type === 'collection') {
        return emptyCollection
      } else if (this.type === 'package') {
        return emptyPackage
      } else {
        return emptyImage
      }
    }
  },
  methods: {
    url(image) {
      return `/media/print-store/${image.printStoreId}/preview/${image.id}/282`
    }
  }
}
</script>
<style lang="scss" scoped>
.empty {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: auto;
  background-position: center;
}

.single {
  width: 100%;
  height: 100%;

  .image {
    width: 100%;
    height: 100%;
  }
}

/* gap i.p.v. space-between: de <img> krimpt binnen zijn wrapper naar de eigen
   verhouding, dus space-between zou een wisselende tussenruimte geven
   afhankelijk van staand/liggend. */
.double {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  .image {
    width: 66px;
    height: 100%;
  }
}

.four {
  width: 100%;
  height: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;

  .image {
    max-width: 66px;
    width: calc(50% - 2.5px);
    height: 66px;
  }
}
</style>
